import type { Line } from '~/api/common/types';

import { clsx } from '~/styles/utils';

import { descriptionStyle, productDescriptionStyle, productNameStyle, textLineStyle } from './documentLine.css';

type Props = {
  line: Line;
};

export const DocumentLineDescriptionCell = ({ line }: Props) => {
  const isProductLine = line.type === 'entry' && line.productName !== null;

  return (
    <div className={clsx(descriptionStyle, line.type === 'text' && textLineStyle)}>
      {isProductLine && <span className={productNameStyle}>{line.productName}</span>}

      <span className={clsx(isProductLine && productDescriptionStyle)}>{line.description}</span>
    </div>
  );
};
